<template>
  <!-- <button :type="type" :style="cssProps">
    <p class="button-txt">{{ text }}</p>
    <fa class="icon" :icon="icon" />
  </button> -->
  <button :style="cssProps">
    <fa id="circular-btn-icon" :icon="icon" />
  </button>
</template>

<script>
export default {
  name: "CircularButton",
  props: {
    color: {
      type: String,
      default: "var(--primary-clr)",
    },
    icon: {
      type: String,
      default: "code",
    },
  },
  computed: {
    cssProps() {
      let display = "none";
      let txtClr = "";

      if (
        this.color == "white" ||
        this.color.toLowerCase() == "#ffffff" ||
        this.color.toLowerCase() == "#fff" ||
        this.color.toLowerCase() == "var(--light-clr)" ||
        this.color.toLowerCase() == "#0000" ||
        this.color.toLowerCase() == "transparent"
      ) {
        txtClr = "#454545";
      } else {
        txtClr = "white";
      }
      if (this.icon !== "code") {
        display = "block";
      }
      return {
        "--icon-display": display,
        "--btn-clr": this.color,
        "--icon-clr": txtClr,
      };
    },
  },
};
</script>

<style scoped>
button {
  width: 5em;
  aspect-ratio: 1;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: var(--btn-clr);
  color: var(--light-clr);
  transition: var(--transition);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1000;
}

button:hover,
button:focus {
  box-shadow: var(--box-shadow-focus);
  /* background: var(--primary-clr); */
}

button::before {
  content: "";
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
  width: 0;
  aspect-ratio: 1;
  transition: var(--transition);
  border-radius: 50%;
}

button:hover::before {
  width: 110%;
}
#circular-btn-icon {
  width: 40%;
  height: 40%;
  color: var(--icon-clr);
}
</style>
